export default __webpack_public_path__ + "static/media/uy.6f3ab525.svg";